import React, {useEffect, useState} from 'react';
import FilterMultiSelect from './FilterMultiSelect';
import {FilterOption} from '../../../common/types/FilterOption';
import {HierarchicalOrganizationalUnit} from '../../../admin/artisticobjects/types/OrganizationalUnit';
import organizationalUnitsService from '../../../admin/artisticobjects/services/organizationalUnitsService';
import {handleError} from '../../../common/utils/errorHandling';

interface LocationFilterDropdownProps {
  hierarchyType: string;
  value: string[];
  onChange: (value: string[]) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
}

const LocationFilterDropdown: React.FC<LocationFilterDropdownProps> = ({
  hierarchyType,
  value,
  onChange,
  onKeyDown
}) => {
  const [hierarchicalUnits, setHierarchicalUnits] = useState<HierarchicalOrganizationalUnit[]>([]);
  const [locationOptions, setLocationOptions] = useState<FilterOption[]>([]);

  const fetchHierarchicalUnits = async () => {
    handleError(async () => {
      const units = await organizationalUnitsService.getHierarchicalOrganizationalUnitsByType(hierarchyType);
      setHierarchicalUnits(units);

      // Convert to FilterOption format with indentation based on level
      const options: FilterOption[] = units.map(unit => ({
        label: '\u00A0'.repeat(unit.level * 4) + unit.name,
        value: unit.id
      }));
      setLocationOptions(options);
    }, `Error fetching ${hierarchyType} organizational units`);
  };

  useEffect(() => {
    fetchHierarchicalUnits();
  }, [hierarchyType]);

  return (
    <FilterMultiSelect
      value={value}
      options={locationOptions}
      onChange={onChange}
      onKeyDown={onKeyDown}
      width={800}
    />
  );
};

export default LocationFilterDropdown;
